import React from 'react';
import FDAList from '../../components/FDA/FDAList';

const FDAPage: React.FC = () => {
    return <FDAList />;
};

export default FDAPage; 